
//
// Inicializace objektu, do kterého se budou ukládat všechny dostupné
// moduly.
//
// Z hlediska modularity javascriptového kódu by se mohlo zdát, že tento způsob vlastně žádnou modularitu
// ve zdrojovém kódu nevytváří. Smyslem zde ale není simulovat nějaký modulární systém javascriptu pro
// správu stromu závislostí, ale o oddělení kódu, který je závislý na externě načítaných
// knihovnách třetích stran a náš kód navazující na tyto knihovny tvoří pouze pár řádků.
//
window.Modules = window.Modules || {};


//
// Vytvoření elementu "script" s cestou ke skriptu, který chceme nahrát.
// Funkce element pouze vytvoří, ale nepřidá jej do DOM stromu, takže se skript (ještě) nezačne nahrávat!
//
window.Modules.createScript = function(scriptPath, callback) {
	var element = document.createElement("script");
	element.async = true;
	element.src = scriptPath;

	// Callback po nahrání skriptu.
	if (callback) {
		element.addEventListener("load", callback)
	}

	return element;
}


//
// Začlenění skriptu do DOM stromu, tj. spuštění jeho nahrávání.
//
window.Modules.runScript = function(scriptElement) {
	document.body.appendChild(scriptElement);
}


//
// Nahrání skriptu ze zadané URL adresy (zkratka za použití výše definovaných funkcí createScript a runScript).
//
window.Modules.loadScript = function(scriptPath, callback) {
	Modules.runScript(Modules.createScript(scriptPath, callback));
}
